import { render, staticRenderFns } from "./user-role-types.vue?vue&type=template&id=62d07af6&"
import script from "./user-role-types.vue?vue&type=script&lang=js&"
export * from "./user-role-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports